@if(isLoading) {
<kzn-loader [message]="'loaderSettingsTokens' | translate"></kzn-loader>
} @else if(isError) {
<kzn-status-message [message]="errorMessage"></kzn-status-message>
} @else {
<div class="settings-page">
  <div class="settings-page__header">
    <div class="settings-page__header-icon">
      <mat-icon>settings</mat-icon>
    </div>
    <span class="settings-page__header-title">{{ 'settingsPageTitle' | translate }}</span>
  </div>

  <div class="settings-page__card">
    <kzn-table
      [data]="allTokens"
      [columns]="tableColumns"
      style="width: 100%"
      [showRefresh]="true"
      (refreshEventFired)="getAllTokens(true)"
    >
      <ng-container header-right>
        <button type="button" class="settings-page__create-btn" (click)="openCreateTokenDialog()">
          <mat-icon>add</mat-icon>{{ 'createAppToken' | translate }}
        </button>
      </ng-container>
    </kzn-table>
  </div>
</div>
}
